import I18n from "i18n-js";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
} from "@mui/material";
import FacebookShare from "../../../components/SocialShare/FacebookShare";
import XShare from "../../../components/SocialShare/XShare";
import TelegramShare from "../../../components/SocialShare/TelegramShare";

export interface WebButtonProps {
  sharingUrl: string;
}

export default function Socials({sharingUrl}: WebButtonProps) {

  return (
    <Card>
      <CardHeader title={I18n.t("Sharing.tools.socials.title")}/>
      <CardContent>
        <Grid container>
          <Grid item md={12} sm={12}>
            <FacebookShare url={sharingUrl} />
            <XShare url={sharingUrl} />
            <TelegramShare url={sharingUrl} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}